import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Spinner } from 'react-bootstrap';
import { IoMdCheckmark, IoMdClose } from 'react-icons/io';
import { IconContext } from 'react-icons';
import { useHistory, useLocation } from 'react-router-dom';
import { useParams } from 'react-router';
import useAxios from 'axios-hooks';
import { useStateValue } from '../state';
import moment from 'moment-timezone';
import TimeRestriction from './TimeRestriction';
import { gojump, gosky, asList } from '../Api/trips';

function PeopleList() {
  let history = useHistory();
  let { locationId, pickupSpot, hour, minute, tripListStatus, driver } = useParams();
  // Which backends this trip spans (see tripDetailsPath): GoJump unless the
  // URL says gojump=0, GoSky when it names the GoSky pickup key.
  const query = new URLSearchParams(useLocation().search);
  const pickupKey = query.get('gosky') || '';
  const withGoJump = query.get('gojump') !== '0';
  const [{ date, showCalendar, roles, apiDate }, dispatch] = useStateValue();
  const [timeRestriction, setTimeRestriction] = useState(false);
  const [modalState, setModalState] = useState(false);
  const [timeDiff, setTimeDiff] = useState(0);

  // console.log(date);
  var selectedDate = date.format('YYYY-MM-DD');

  useEffect(() => {
    const selectedDateTime = moment(`${selectedDate} ${hour}:${minute}`, 'YYYY-MM-DD HH:mm');

    const diffMinutes = selectedDateTime.diff(apiDate, 'minutes');
    console.log(diffMinutes);

    if (diffMinutes > 20) {
      setTimeRestriction(true);
      const days = Math.floor(diffMinutes / 1440);
      const remainingAfterDays = (diffMinutes - 20) % 1440;
      const hours = Math.floor(remainingAfterDays / 60);
      const minutes = remainingAfterDays % 60;

      let formattedTime = [];
      if (days > 0) {
        formattedTime.push(`${days} day${days > 1 ? 's' : ''}`);
      }
      if (hours > 0) {
        formattedTime.push(`${hours} hour${hours > 1 ? 's' : ''}`);
      }
      if (minutes > 0 || formattedTime.length === 0) {
        formattedTime.push(`${minutes} minute${minutes !== 1 ? 's' : ''}`);
      }

      setTimeDiff(formattedTime.join(', '));
    } else {
      setTimeRestriction(false);
    }
  }, [selectedDate, hour, minute, apiDate]);

  const [loadingState, setLoading] = useState(0);

  const [people, setPeople] = useState([]);

  var tripStatus = 0;

  const [{ data: rawGoJump, loading, error }] = useAxios(
    { url: withGoJump ? gojump.detailsUrl(selectedDate, locationId, pickupSpot, hour, minute) : null },
    { useCache: false, manual: !withGoJump },
  );
  const [{ data: rawGoSky, loading: goskyLoading, error: goskyError }] = useAxios(
    { url: pickupKey ? gosky.detailsUrl(selectedDate, pickupKey, hour, minute) : null },
    { useCache: false, manual: !pickupKey },
  );

  // Saves go to each company's own server; the URL (status) is set per call.
  const [{ loading: putLoading, error: putError }, executeGoJump] = useAxios({ method: 'POST' }, { manual: true });
  const [{ loading: putLoading2, error: putError2 }, executeGoSky] = useAxios({ method: 'POST' }, { manual: true });

  const total = people.reduce((prevValue, currentValue) => prevValue + currentValue.numberOfPeople, 0);

  const handleClick = (idx, checked) => {
    const updatedPeople = [...people];

    let updatedPerson = { ...updatedPeople[idx] };

    updatedPerson.pickupStatus = checked;
    updatedPeople[idx] = updatedPerson;

    setPeople(updatedPeople);
  };
  const updateData = async (val) => {
    const marks = (source) =>
      people
        .filter((person) => person.source === source)
        .map((person) => ({ id: person.id, status: person.pickupStatus }));
    if (timeRestriction) {
      setModalState(true);
    } else {
      const saves = [];
      if (withGoJump) {
        saves.push(
          executeGoJump({
            url: gojump.saveUrl(selectedDate, locationId, pickupSpot, hour, minute, val),
            data: gojump.saveBody(marks('gojump')),
          }),
        );
      }
      if (pickupKey) {
        saves.push(
          executeGoSky({
            url: gosky.saveUrl(selectedDate, pickupKey, hour, minute, val),
            data: gosky.saveBody(marks('gosky')),
          }),
        );
      }
      try {
        await Promise.all(saves);
      } catch (e) {
        return; // the hook's error renders the "changes may not be saved" message
      }
      history.push(`/`);
    }
  };

  if (loading || goskyLoading || putLoading || putLoading2)
    return (
      <div>
        <Spinner
          className="text-center d-flex justify-center align-center margn-auto"
          animation="border"
          variant="primary"
        />
      </div>
    );
  if (error || goskyError) return <p>Error!</p>;
  if (putError || putError2) return <p>Your internet connection failed, recent changes may not be saved. </p>;
  const gojumpReady = !withGoJump || rawGoJump;
  const goskyReady = !pickupKey || rawGoSky;
  if (loadingState == 0 && gojumpReady && goskyReady) {
    setLoading(1);
    setPeople([
      ...(withGoJump ? asList(rawGoJump) : []).map((person) => ({ ...person, source: 'gojump' })),
      ...(pickupKey ? asList(rawGoSky) : []).map((person) => ({ ...person, source: 'gosky' })),
    ]);
  }

  return (
    <div>
      <TimeRestriction modalState={modalState} onClose={() => setModalState(false)} text={timeDiff} />
      <Container className="mt-3 main-wrapper" id="trip-list">
        {driver != 'none' ? (
          <div className="text-center subtitle list-tip">
            Pickup completed by <b>{driver}</b>
          </div>
        ) : (
          ' '
        )}
        <div className="list-wrapper">
          <div className="subtitle list-tip">Total {total} people</div>
          {people &&
            people.map((people, idx) => (
              <Row className="people-list-item" key={idx}>
                <Col xs={7}>
                  <div className="title">{people.name}</div>
                  <div className="subtitle">
                    <span> {people.numberOfPeople} people </span>
                    {people.source === 'gosky' && <span className="badge-gosky">GoSky Hawaii</span>}
                  </div>
                </Col>
                <Col xs={5} className="text-right pr-2 my-auto d-flex justify-content-end">
                  <button
                    className={`button-small mr-3 ${people.pickupStatus === null ? 'button-small-subtle' : ''}
                                                   ${people.pickupStatus === 0 ? 'button-small-active' : ''}
                                                   `}
                    onClick={() => handleClick(idx, 0)}>
                    <IconContext.Provider value={{ size: '1.5em' }}>
                      <IoMdClose />
                    </IconContext.Provider>
                  </button>
                  <button
                    className={`button-small mr-3 ${!people.pickupStatus === null ? 'button-small-subtle' : ''}
                                                   ${people.pickupStatus === 1 ? 'button-small-active' : ''}
                                                   `}
                    onClick={() => handleClick(idx, 1)}>
                    <IconContext.Provider value={{ size: '1.5em' }}>
                      <IoMdCheckmark />
                    </IconContext.Provider>
                  </button>
                </Col>
              </Row>
            ))}
        </div>
      </Container>
      <Row>
        <Col xs={6}>
          {tripListStatus != 0 ? (
            <button className="button-large button-large-outline" onClick={() => updateData(0)}>
              Mark as incomplete
            </button>
          ) : (
            ''
          )}
        </Col>
        {tripListStatus == 0 ? (
          <Col xs={12}>
            <button className="button-large " onClick={() => updateData(1)}>
              Pickup complete
            </button>
          </Col>
        ) : (
          <Col xs={6}>
            <button className="button-large button-large-half" onClick={() => updateData(1)}>
              Save
            </button>
          </Col>
        )}
      </Row>
    </div>
  );
}

export default PeopleList;
